import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c9f80e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-page page d-flex flex-column" }
const _hoisted_2 = { class: "page-content d-flex flex-grow-1" }
const _hoisted_3 = { class: "dashboard-content-wrapper" }

import AppHeader from "@/components/Pages/AppHeader.vue";
import NotificationBar from "@/components/Other/NotificationBar.vue";
import DashboardSidebar from "@/components/Pages/Dashboard/DashboardSidebar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, {
      "show-project": false,
      "show-survey": false,
      "show-edit-project-button": false,
      "show-share-button": false
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DashboardSidebar),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})